// extracted by mini-css-extract-plugin
export var baseButton = "_tq-0";
export var controlsArrowKeys = "_tq-1";
export var controlsResetButton = "_tq-2";
export var lightGameButton = "_tq-4 _tq-0";
export var playAgainButton = "_tq-5 _tq-0";
export var startGameButton = "_tq-3 _tq-0";